__turbopack_context__.v({
  "className": "ozik_87016154-module__u2QQta__className",
  "variable": "ozik_87016154-module__u2QQta__variable",
});
